import { render, staticRenderFns } from "./coustmEmpty.vue?vue&type=template&id=ccd78932&scoped=true&"
import script from "./coustmEmpty.vue?vue&type=script&lang=js&"
export * from "./coustmEmpty.vue?vue&type=script&lang=js&"
import style0 from "./coustmEmpty.vue?vue&type=style&index=0&id=ccd78932&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd78932",
  null
  
)

export default component.exports